// extracted by mini-css-extract-plugin
export default {"HatchLogo":"HatchLogo_HatchLogo__G42Zg","hatchimg":"HatchLogo_hatchimg__sFdqh"};